import { render, staticRenderFns } from "./CheckGender.vue?vue&type=template&id=d822ef42&scoped=true&"
import script from "./CheckGender.vue?vue&type=script&lang=js&"
export * from "./CheckGender.vue?vue&type=script&lang=js&"
import style0 from "./CheckGender.vue?vue&type=style&index=0&id=d822ef42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d822ef42",
  null
  
)

export default component.exports